"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkbox = void 0;
const tw_1 = require("../utils/tw");
exports.checkbox = (0, tw_1.tw)(`
  peer my-[0.19rem] flex size-[18px] flex-shrink-0 items-center justify-center
  self-start rounded-2xs border-md border-tertiary bg-transparent p-none text-xs
  text-inverse outline-none
  data-[hover]:cursor-pointer data-[hover]:border-neutral-hover
  data-[checked]:border-brand data-[checked]:data-[hover]:border-brand-hover
  data-[checked]:bg-brand data-[checked]:data-[hover]:bg-brand-hover
  data-[disabled]:border-neutral-disabled
  data-[disabled]:data-[checked]:bg-support-disabled
  data-[disabled]:text-inverse
  data-[invalid]:border-critical
  data-[focused]:outline-2 data-[focused]:outline-offset-2
  data-[focused]:outline-tertiary
  [&:user-invalid]:border-critical
`);
